<template lang="pug">
v-row
  v-col
    h1.mb-4 Списки зачислений
    crud-scroll-details.pa-2(
      ref="list"
      :detailsComponent="detailsComponent"
      :adapter="adapter"
      :query="query"
      :queryField="{ label: 'Номер договора', key: 'search[number]' }"
    )
      template(#list-item="{ item, opencu }")
        v-list-item-avatar
          v-badge(
            dot overlap
            :value="item.chat.exists_unread_messages"
            color="error"
            offset-x="18"
            offset-y="18"
          )
            v-avatar
              v-icon(
              ) {{ item.users.length > 1 ? 'mdi-account-multiple' : 'mdi-account' }}
        v-list-item-content
          v-list-item-title {{ item.number }}
        v-alert.mb-0(
          dense text
          :color="item.isPaymentPrePayment && item.is_active ? 'success' : 'error'"
        )
          .text-h6 {{ item.is_active ? `${item.paymentPercent} %` : 'Аннулирован' }}

</template>

<script>
import { mapGetters } from 'vuex';
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import ListDetail from '../components/ListDetail.vue';

export default {
  components: {
    CrudScrollDetails,
  },
  props: {
  },
  data() {
    return {
      detailsComponent: {
        component: ListDetail,
        component_attrs: {
          isEnrollment: true,
        },
        component_listeners: {
          update: (id) => {
            this.selectById(id);
          },
          unSelect: () => { this.$refs.list.unSelect(); this.$refs.list.refreshList(); },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
    }),
    query() {
      const resulst = {
        ...this.$route.query.id ? {} : { 'search[is_active]': true },
      };
      return resulst;
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.selectById(this.$route.query.id);
      setTimeout(() => this.$router.replace({ query: {} }), 100);
    }
  },
  methods: {
    selectById(id) {
      this.$refs.list.selectById(id);
    },
    adapter(params) {
      return this.$api.contracts.getContractsModel({
        expand: 'is_signed_customer_act,is_signed_executor_act,users,transactions,typical_contract_discount,typical_contract,document,is_signed_executor,is_signed_customer,owner,act',
        'search[owner_id]': this.userData.id,
        ...params,
      });
    },
  },
};
</script>
